import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import { ConversationService } from '@forwardflow/services/ConversationService'
import useSWR from 'swr'

interface AppointmentStatusResponse {
   isAppointmentSetEnabled: boolean
}

interface useSetAppointmentStatusParams {
   leadId?: number
   shouldFetch?: boolean
}

export const useSetAppointmentStatus = ({ 
   leadId, 
   shouldFetch = true 
}: useSetAppointmentStatusParams) => {
   const response = useSWR<AppointmentStatusResponse>(
      shouldFetch && leadId ? [QUERY_KEYS.SET_APPOINTMENT_STATUS, leadId] : null,
      () => ConversationService.getSetAppointmentStatus(leadId!),
      {
         shouldRetryOnError: false,
      }
   )
   return {
      ...response,
      mutate: () => response.mutate()
   }
}